import {ErrorFlow, Brick, registerBrick} from 'olympe';
import he from 'he';
/**
 * This function takes a string of HTML and decodes any named and numerical character references in it
 * using the algorithm described in section 12.2.4.69 of the HTML spec.
 */
export default class DecodeHTML extends Brick {
    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {string} stringToDecode
     * @param {function(string)} setDecodedString
     * @param {function(ErrorFlow)} setErrorFlow
     */
    update($, [stringToDecode], [setDecodedString, setErrorFlow]) {
        try {
            setDecodedString(he.decode(stringToDecode));
        } catch (e) {
            setErrorFlow(ErrorFlow.create('Cannot decode HTML: ' + e, 1));
        }
    }
}

registerBrick('01969f81654617746eee', DecodeHTML);
